import ReactMarkdown from 'react-markdown'
import boltorange from './../sprites/boltorange-250-min.png'
import boltred from './../sprites/boltred-250-min.png'
import boltyellow from './../sprites/boltyellow-250-min.png'
import spritegrey from './../sprites/virusunknown-250-min.png'
import logo from './../images/logo.svg'

function EndScreen (props) {

  const {messagePool, restartGame, score, scores} = props

  const totalScore = () => {
    return (score + 
      scores.antibioticsWasted.red * messagePool.wasteMessages[0][1] + 
      scores.antibioticsWasted.orange * messagePool.wasteMessages[0][1] + 
      scores.antibioticsWasted.red * messagePool.wasteMessages[0][1] +
      scores.unidentifiedBugs.hit * messagePool.unidentifiedPenMessages[0][1] +
      scores.unidentifiedBugs.ignored * messagePool.unidentifiedBonMessages[0][1]
    )
  }


  return (
   
   scores && messagePool ? <>
         <h1>Battling the Bugs</h1>

   <p id="initialEndScore">You scored {score}!</p>

   <p className="scoreSectionHead">Penalties</p>
   <div>

    <div className="scoreLine"><div className="scoreEndS">{scores.antibioticsWasted.yellow}</div><div className="scoreBug" style={{
          backgroundImage: `url(${boltyellow})`,
        }}></div><div className="scoreText">antibiotic{scores.antibioticsWasted.yellow === 1 ? "" : "s"}  wasted: {scores.antibioticsWasted.yellow * messagePool.wasteMessages[0][1]} points</div></div>
  
    <div className="scoreLine"><div className="scoreEndS">{scores.antibioticsWasted.orange}</div><div className="scoreBug"style={{
          backgroundImage: `url(${boltorange})`,
          transform: `rotate(180deg)`

        }}></div><div className="scoreText">antibiotic{scores.antibioticsWasted.orange === 1 ? "" : "s"}  wasted: {scores.antibioticsWasted.orange * messagePool.wasteMessages[0][1]} points</div></div>
       <div className="scoreLine"><div className="scoreEndS">{scores.antibioticsWasted.red}</div><div className="scoreBug" style={{
          backgroundImage: `url(${boltred})`
        }}></div><div className="scoreText">antibiotic{scores.antibioticsWasted.red === 1 ? "" : "s"} wasted: {scores.antibioticsWasted.red * messagePool.wasteMessages[0][1]} points</div></div>
  
   </div>
   <div className="learning">    {String(messagePool.wasteMessages[0][0]).split("<<").map ( (p,i) =>
  p.trim().length > 0 ? 
    
    <ReactMarkdown key={i}>{p}</ReactMarkdown>
    
   : <p key={i} className="spacer"></p>)
}</div>
  

   <div className="scoreLine"><div className="scoreEndS">{scores.unidentifiedBugs.hit}</div><div className="scoreBug" style={{
          backgroundImage: `url(${spritegrey})`
        }}></div><div className="scoreText">unidentified bug{scores.unidentifiedBugs.hit === 1 ? "" : "s"} hit: {scores.unidentifiedBugs.hit * messagePool.unidentifiedPenMessages[0][1]} points</div></div>
  
 
  <div className="learning">  {String(messagePool.unidentifiedPenMessages[0][0]).split("<<").map ( (p,i) =>
  p.trim().length > 0 ? 
    
    <ReactMarkdown key={i}>{p}</ReactMarkdown>
    
  : <p key={i} className="spacer"></p>) 
}</div>
   <p className="scoreSectionHead" >Bonus points</p>
   
   <div className="scoreLine"><div className="scoreEndS">{scores.unidentifiedBugs.ignored}</div><div className="scoreBug" style={{
          backgroundImage: `url(${spritegrey})`
        }}></div><div className="scoreText">unidentified bug{scores.unidentifiedBugs.ignored === 1 ? "" : "s"} ignored: {scores.unidentifiedBugs.ignored * messagePool.unidentifiedBonMessages[0][1]} points</div></div>
  
   
  <div className="learning"> {String(messagePool.unidentifiedBonMessages[0][0]).split("<<").map ( (p,i) =>
  p.trim().length > 0 ? 
    
    <ReactMarkdown key={i}>{p}</ReactMarkdown>
    
: <p key={i} className="spacer"></p>)
}</div>
    
    <p className="scoreSectionHead">Total score</p>
    <p className="finalEndScore">{totalScore()}</p>

   <div className="learning"> {String(messagePool.outroMessages[0][0]).split("<<").map ( (p,i) =>
  p.trim().length > 0 ? 
    
    <ReactMarkdown key={i}>{p}</ReactMarkdown>
    
     : <p key={i} className="spacer"></p>)
}</div> 
   <div onClick={restartGame}  className="startButton endButton" ><span>RESTART</span></div>
   <div id="logo" style={{
   marginTop: "0.5em",
   width: "100%",
   zIndex: -1,
    backgroundImage: `url(${logo})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center"
  }}></div>
   
   </>
   
   
   : ""
   
  )
}

export default EndScreen